<template>
  <div class="animated fadeIn dash-main">
    <b-row>
      <b-col md='12' lg='4'>
        <router-link :to="{ path: '/templates'}">
          <b-card no-body class="dash-box">
            <b-card-body class="p-6">
              <b-row class="dash-row">
                <b-col xs='9' class="pr-0">
                  <h1 class="mb-0">{{ $t('Templates') }}</h1>
                  <h4><animated-number :value="totalTemplate || 0" :formatValue="formatNumber" :duration="1000"/></h4>
                </b-col>
                <b-col xs='9'>
                  <div v-html="svg.templates"></div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </router-link>
      </b-col>
      <b-col md='12' lg='8'>
        <router-link :to="{ path: '/process/processed'}">
          <b-card no-body class="dash-box">
            <b-card-body class="pb-6">
              <b-row class="dash-row">
                <b-col cols="10">
                  <h1 class="mb-0">{{ $t('Forms') }}</h1>
                  <div class="process-datas">
                    <div class="process-data" v-for="(count, processed) in processForms">
                      <h4 :class="'processed-' + processed"><animated-number :value="count || 0" :formatValue="formatNumber" :duration="1500"/></h4>
                      <h3 class> {{ $t('COMMON.'+processed.toUpperCase()) }} </h3>
                    </div>
                  </div>
                </b-col>
                <b-col cols="2">
                  <div v-html="svg.forms"></div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </router-link>
      </b-col>
    </b-row>
    <b-row class="second-row">
      <b-col md='6' lg='3' v-for="(box, index) in boxes" :key="index" v-if=box.show>
        <router-link :to="{ path: box.path }">
          <b-card no-body class="dash-box">
            <b-card-body class="pb-6">
              <b-row class="dash-row">
                <b-col xs='7'>
                  <h1 class="mb-0">{{ $t(box.name) }}</h1>
                </b-col>
                <b-col xs='5'>
                  <div v-html="svg[box.icon]"></div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </router-link>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import svg from '../../_svg.js'
import AnimatedNumber from 'animated-number-vue'

export default {
  data () {
    return {
      totalTemplate: 0,
      svg: svg,
      boxes: [
        {name: 'Reports', icon: 'reports', path: '/reports/form', show: true},
        {name: 'Models', icon: 'Models', path: '/super_admin/models', show: false},
        {name: 'Users', icon: 'users', path: '/admin/users', show: false},
        {name: 'Logs', icon: 'logs', path: 'audits/trail', show: false},
        {name: 'Settings', icon: 'settings', path: '/settings/configure', show: false}
      ],
      processForms: null,
      teamID: null,
      userID: null
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isSuperAdmin', 'idToken', 'isAdminRole']),
    show_all () {
      return this.isAdmin || this.isSuperAdmin
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.boxes.slice(1).forEach(function (box, index) {
        if (box['name'] === 'Settings') {
          box['show'] = vm.isAdmin
        } else if (box['name'] === 'Models') {
          box['show'] = vm.isSuperAdmin
        } else {
          box['show'] = (vm.isAdmin || vm.isSuperAdmin)
        }
      })
      Vue.axios.get('/reports/teams_and_users', { headers: { Authorization: `Bearer ${vm.idToken}` } })
        .then(res => {
          vm.userID = vm.isAdminRole ? null : res.data.user_id
          vm.teamID = vm.isAdminRole ? -1 : res.data.team_id
          vm.fetchReports()
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            next(false)
          }
        })
    })
  },
  created () {
    this.fetchDailyReports()
  },
  methods: {
    formatNumber (value) {
      return value.toFixed(0)
    },
    fetchDailyReports () {
      Vue.axios.get('reports/daily_report', { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
        })
        .catch(error => {
          console.log(error)
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchReports () {
      Vue.axios.get('/template_docs', { headers: { Authorization: `Bearer ${this.idToken}` }, params: { teamID: this.teamID, userID: this.userID } })
        .then(res => {
          this.totalTemplate = res.data.template_docs.length
          this.processForms = res.data.processed_forms
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    }
  },
  components: {
    AnimatedNumber
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/main.vue